import { Badge } from 'keep-react'
import { translateClaimsStatus } from './translateStatus'
import { ClaimsStatus } from 'api/types/claims'

export const renderClaimsBadge = (status: ClaimsStatus) => {
  let color: 'error' | 'success' | 'warning' | 'primary' | 'secondary' =
    'secondary'

  switch (status) {
    case 'PENDING ':
      color = 'warning'
      break
    case 'CANCEL  ':
      color = 'error'
      break
    case 'APPROVED':
    default:
      color = 'success'
      break
  }

  return (
    <Badge className="pointer-events-none" color={color} variant="background">
      {translateClaimsStatus(status)}
    </Badge>
  )
}
